import React, { useEffect, useState, useRef } from "react";
import { Form, FormGroup, Label, Input, Row, Col } from "reactstrap";
import "./ReactQuills";
import "../Banner/banner.css";
import api from "../../Axios";
import NotificationAlert from "react-notification-alert";
import { useHistory, useParams } from "react-router-dom";
import Swal from "sweetalert2";

const EditMembershipPlan = () => {
  const notiRef = useRef();
  const { id } = useParams();
  const history = useHistory();
  const [data, setData] = useState({
    selectPlan: "",
    name: "",
    duration: "",
    period: "",
    sendInterest: "",
    viewHoroscope: "",
    viewContactNos: "",
    chat: "",
    profileHighlighter: "",
    brokerService: "",
    regularPrimeChat: "",
    regularPrice: "",
    offerPrice: "",
    status: "active",
  });

  // Fetch membership plan details on mount
  useEffect(() => {
    api
      .post("/admin/membership/getSingleMembership", { id })
      .then((res) => {
        if (res.data.data) {
          setData(res.data.data);
        }
      })
      .catch(() => {
        Swal.fire("Error", "Failed to fetch membership details", "error");
      });
  }, [id]);

  // Handle input changes
  const handleChange = (e) => {
    const { name, value, type } = e.target;
    if (type === "number" && value < 0) return; // prevent negative values
    setData((prev) => ({ ...prev, [name]: value }));
  };

  // Handle submit update
  const handleSubmit = (e) => {
    e.preventDefault();
    const postingData = {
      ...data,
      duration: parseInt(data.duration) || 0,
      sendInterest: parseInt(data.sendInterest) || 0,
      viewHoroscope: parseInt(data.viewHoroscope) || 0,
      viewContactNos: parseInt(data.viewContactNos) || 0,
      chat: parseInt(data.chat) || 0,
      profileHighlighter: parseInt(data.profileHighlighter) || 0,
      brokerService: parseInt(data.brokerService) || 0,
      regularPrimeChat: parseInt(data.regularPrimeChat) || 0,
      regularPrice: parseInt(data.regularPrice) || 0,
      offerPrice: parseInt(data.offerPrice) || 0,
    };

    api.post("/admin/membership/updateMembership", postingData).then((res) => {
      if (res.data.data === "Updated successfully") {
        Swal.fire(
          "Updated!",
          "Membership plan updated successfully.",
          "success"
        );
        history.push(`viewmembership`);
      } else {
        Swal.fire("Error", "Something went wrong", "error");
      }
    });
  };

  return (
    <div className="content">
      <div className="notification-popup">
        <NotificationAlert ref={notiRef} />
      </div>
      <Row>
        <Col xs={12}>
          <div className="page-title">
            <div className="float-left">
              <h1 className="title">Membership Plan</h1>
            </div>
          </div>
          <div className="col-12">
            <section className="box">
              <header className="panel_header">
                <h1
                  className="title float-left"
                  style={{
                    textTransform: "capitalize",
                    fontWeight: "500",
                    padding: "50px 50px",
                  }}
                >
                  Edit Membership Plan
                </h1>
              </header>
              <div className="content-body">
                <div className="row">
                  <div className="col-12 col-sm-12 col-md-10 col-lg-10 col-xl-8">
                    <Form onSubmit={handleSubmit}>
                      {/* Select Plan */}
                      <FormGroup>
                        <label>Select Plan</label>
                        <select
                          onChange={handleChange}
                          name="selectPlan"
                          className="form-select"
                          value={data.selectPlan}
                        >
                          <option value="regular">Regular</option>
                          <option value="prime">Prime</option>
                        </select>
                      </FormGroup>

                      {/* Name Dropdown */}
                      <FormGroup>
                        <Label>Name</Label>
                        <Input
                          type="select"
                          name="name"
                          onChange={handleChange}
                          value={data.name}
                        >
                          <option value="gold">Gold</option>
                          <option value="diamond">Diamond</option>
                          <option value="elite">Elite</option>
                        </Input>
                      </FormGroup>

                      {/* Period */}
                      <FormGroup>
                        <label>Period</label>
                        <select
                          onChange={handleChange}
                          name="period"
                          className="form-select"
                          value={data.period}
                        >
                          <option value="days">Day</option>
                          <option value="months">Month</option>
                          <option value="years">Year</option>
                        </select>
                      </FormGroup>

                      {/* Numeric Fields */}
                      {[
                        { label: "Duration", name: "duration" },
                        { label: "No of Sent Interest", name: "sendInterest" },
                        {
                          label: "No of View Horoscope",
                          name: "viewHoroscope",
                        },
                        {
                          label: "No of View Contact Number",
                          name: "viewContactNos",
                        },
                        { label: "No of Chat", name: "chat" },
                        {
                          label: "Profile Highlighter",
                          name: "profileHighlighter",
                        },
                        { label: "Broker Service", name: "brokerService" },
                        {
                          label: "Regular Prime Chat",
                          name: "regularPrimeChat",
                        },
                        { label: "Price", name: "regularPrice" },
                        { label: "Offer Price", name: "offerPrice" },
                      ].map(({ label, name }) => (
                        <FormGroup key={name}>
                          <Label>{label}</Label>
                          <Input
                            type="number"
                            min="0"
                            onKeyDown={(e) => {
                              if (e.key === "-" || e.key === "e")
                                e.preventDefault();
                            }}
                            onChange={handleChange}
                            name={name}
                            value={data[name]}
                          />
                        </FormGroup>
                      ))}

                      {/* Status */}
                      <FormGroup>
                        <label>Status</label>
                        <select
                          onChange={handleChange}
                          name="status"
                          className="form-select"
                          value={data.status}
                        >
                          <option value="active">Active</option>
                          <option value="inactive">Inactive</option>
                        </select>
                      </FormGroup>

                      {/* Submit */}
                      <FormGroup style={{ marginBottom: "0px" }}>
                        <button
                          type="submit"
                          className="btn"
                          style={{
                            padding: "5px 10px",
                            background: "black",
                            color: "white",
                            fontWeight: "500",
                          }}
                        >
                          Update
                        </button>
                      </FormGroup>
                    </Form>
                  </div>
                </div>
              </div>
            </section>
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default EditMembershipPlan;
